import React from 'react'
import { cn, RectangleButton, BottomSheet } from '@yanolja-rnd/nol-design-system'
import { getDeviceTypeFromUserAgent } from '~/api/util'

type GoldClassBenefitsProps = {
  /** 바텀 시트 오픈 여부 */
  isOpen: boolean
  /** 바텀 시트 닫기 핸들러 */
  onClose: () => void
  /** 계속 구매하기 버튼 클릭 핸들러 */
  onClickContinuePurchaseButton: () => void
  /** 할인 가격 텍스트 */
  vipDiscountPriceText: string
}

const GoldClassBenefitsBottomSheet: React.FC<GoldClassBenefitsProps> = ({
  isOpen,
  onClose,
  onClickContinuePurchaseButton,
  vipDiscountPriceText,
}) => {
  const deviceType = getDeviceTypeFromUserAgent()

  return (
    <BottomSheet
      isOpen={isOpen}
      os={deviceType}
      zIndex={1}
      height="contents"
      footer={
        <RectangleButton
          theme="filled_primary"
          weight="bold"
          fullWidth
          size="large"
          onClick={() => {
            onClickContinuePurchaseButton()
            onClose()
          }}
        >
          계속 구매하기
        </RectangleButton>
      }
      onClose={onClose}
      dialogOptions={{
        onBackdropClick: () => {
          deviceType === 'etc' && onClose()
        },
      }}
    >
      <div
        className={cn('px-16 py-20 text-center typography-subtitle-16-bold-multiline', 'pc:px-0')}
      >
        <div className="rounded-12 bg-fill-warning-weak px-16 py-10">
          <span>Gold Class 혜택이 적용되어</span>
          <br />
          <span className="text-text-accent-medium">{vipDiscountPriceText}</span>
          <span> 더 할인받았어요!</span>
        </div>
      </div>
    </BottomSheet>
  )
}

export default GoldClassBenefitsBottomSheet
